import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 3H1v18h22V3zM12 18c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
}), 'VignetteSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/VignetteSharp.js
// module id = 7133
// module chunks = 2